import React from 'react';
import {
  Drawer,
  Box,
  Typography,
  IconButton,
  useTheme,
  Divider,
} from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { StatusTag } from './styles';
// import CancelIcon from '@mui/icons-material/Cancel';

interface DetailModalProps {
  open: boolean;
  onClose: () => void;
  shiftId: number;
  shiftStatus: 'Completed' | 'InProgress' | 'Pending' | string;
  children: React.ReactNode;
}

const DetailModal: React.FC<DetailModalProps> = ({
  open,
  onClose,
  shiftId,
  shiftStatus,
  children,
}) => {
  const theme = useTheme();

  const handleClose = (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (reason === 'backdropClick') {
      return;
    }
    onClose();
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          width: 380,
          // height: '100vh',
          // maxHeight: '100vh',
          boxShadow: theme.shadows[10],
          backgroundColor: theme.palette.background.default,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      {/* 1. Fixed Header Section (Includes the bottom border/separator) */}
      <Box
        sx={{
          p: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          // --- KEY CHANGE: Re-adding the full-width bottom border ---
          // borderBottom: `1px solid ${theme.palette.divider}`,
          // ----------------------------------------------------------
          bgcolor: theme.palette.background.paper,
          flexShrink: 0,
        }}
      >

        <Box>
          <Typography variant="h5" fontWeight={600} color="primary">
            Shift ID : {shiftId}
          </Typography>
          <StatusTag status={shiftStatus}>
            {shiftStatus}
          </StatusTag>
        </Box>

        <IconButton onClick={onClose} size="medium" sx={{ color: theme.palette.action.active }}>
          <HighlightOffIcon fontSize="medium" />
        </IconButton>
      </Box>

      <Divider variant="middle" />

      {/* 2. Scrollable Content Area */}
      <Box
        sx={{
          flexGrow: 1,
          overflowY: 'auto',
          bgcolor: theme.palette.background.paper,
        }}
      >
        {/*
          --- KEY CHANGE: Removing the custom small centered Box divider ---
          The full-width separation is now handled by the Header's borderBottom property.
        */}

        {/* Dynamic Content (Children) */}
        {children}

      </Box>
    </Drawer>
  );
};

export default DetailModal;